import { customCreateApi } from '../../context';
import { createDynamicBaseQuery } from '../../utils/create-dynamic-base-query';
import { isAppContextState } from '../app-context-slice';
import { selectAuraConfiguration } from '../configuration/configuration-slice';
import { getAccessToken } from '../session-slice';

export const sharedStorageApi = customCreateApi({
  baseQuery: createDynamicBaseQuery((state) => selectAuraConfiguration(state)?.storageApiUrl, {
    prepareHeaders: async (headers, { getState }) => {
      const accessToken = await getAccessToken();
      headers.set('Authorization', `Bearer ${accessToken}`);

      const state = getState();
      if (isAppContextState(state)) {
        const projectId = state.appContext.activeProjectId;
        if (projectId !== null) {
          headers.set('Project-Id', projectId);
        }
      }
    },
  }),
  reducerPath: 'sharedStorageApi',
  endpoints: () => ({}),
});
